export default "https://cdn-static.gokick.com/assets/96917af4b324ebd1ae50a0309f8a33967fe87b4d/images/tangerine-flavor.1fe86552bc4a40407da21340599dcac8.png";